import { Fragment } from 'react'

import { clamp, easeInOut, smooth, step } from '../springs'
import { Avatar, I, Icon, at, lerpX, show } from './common'
import { DIMS, TRANSIT } from './sceneNeed'

/*
 * Szene 2: Lena spielt das Assessment am Smartphone, im Zeitraffer in rund
 * 14 Minuten. Danach sieht HR die Passung zur Stelle wie im Passungsprofil.
 */

const GAMES = [
  ['Codeknacker', 'Merkfähigkeit', 12.9, 14],
  ['Hochstapler', 'Problemlösefähigkeit', 14, 15.1],
  ['Gefühlschaos', 'Emotionswahrnehmung', 15.1, 16.2],
  ['Selbsterkenntnis', 'Persönlichkeit', 16.2, 17]
]
const PLAY = [12.9, 17]
const MINUTES = 14.1

// Spielfeld 3 × 2 Kacheln, Lena tippt auf jedem Beat eine an
const TILE_X = [-94.7, 0, 94.7]
const TILE_Y = [-74, 22]
const TAPS = [0, 4, 2, 3, 5, 1, 4, 0]
export const TAP_TIMES = TAPS.map((_, k) => 13 + k * 0.5)
export const TAP_POS = TAPS.map((i) => [
  TILE_X[i % 3] + 8,
  TILE_Y[Math.floor(i / 3)] + 10
])

// Passung zur Stelle
const BX0 = -248
const BX1 = 248
const PERSON = [84, 88, 66, 44]
const MROW = (i) => -48 + i * 52
const HINT_ROW = 3
export const MATCH_HOVER = [
  lerpX(BX0, BX1, PERSON[HINT_ROW]) + 6,
  MROW(HINT_ROW) + 10
]
const SCORE = 82

function Play() {
  return (
    <>
      <Avatar name='Lena M' size={32} tone='blue' style={at(-150, -192)} />
      <span className='mo-title' style={at(-108, -192)}>
        Lena M.
      </span>
      <span className='mo-sub' style={at(-108, -172)}>
        Assessment · Account Manager
      </span>
      <span className='mo-timer mo-right' style={at(156, -188)}>
        <Icon d={I.clock} size={14} />
        <span data-mo='pl-timer'>00:00</span>
      </span>
      <span className='mo-game' style={at(-156, -136)}>
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <i key={i} data-mo='pl-tile' />
        ))}
      </span>
      {GAMES.map(([name, dim]) => (
        <Fragment key={name}>
          <span className='mo-h' data-mo='pl-name' style={at(-156, 102)}>
            {name}
          </span>
          <span className='mo-sub' data-mo='pl-dim' style={at(-156, 130)}>
            {dim}
          </span>
        </Fragment>
      ))}
      {GAMES.map(([name], i) => (
        <span key={name} className='mo-seg' style={at(-156 + i * 80, 170)}>
          <i data-mo='pl-seg' />
        </span>
      ))}
    </>
  )
}

function Done() {
  return (
    <>
      <span className='mo-ic mo-ic--green' style={at(-182, -18)}>
        <Icon d={I.check} size={18} width={2} />
      </span>
      <span className='mo-title' style={at(-132, -19)}>
        Assessment abgeschlossen
      </span>
      <span className='mo-sub' style={at(-132, 1)}>
        Lena M. · 4 Spiele · 14 Min.
      </span>
      <span className='mo-badge mo-badge--green mo-right' style={at(182, -11)}>
        Abgeschlossen
      </span>
    </>
  )
}

function Match() {
  return (
    <>
      <Avatar name='Lena M' size={44} tone='blue' style={at(-248, -172)} />
      <span className='mo-title' style={at(-192, -170)}>
        Lena M.
      </span>
      <span className='mo-sub' style={at(-192, -149)}>
        Account Manager Vertrieb
      </span>
      <span className='mo-cap mo-cap--muted mo-right' style={at(248, -172)}>
        Passung zur Stelle
      </span>
      <span
        className='mo-score-num mo-right'
        data-mo='mc-score'
        style={at(138, -152)}
      >
        0
      </span>
      <span
        className='mo-badge mo-badge--fit mo-right'
        data-mo='mc-tag'
        style={at(248, -145)}
      >
        Sehr passend
      </span>
      <span className='mo-rule' style={{ ...at(-264, -104), width: 528 }} />
      {DIMS.map(([label, lo, hi]) => {
        const i = DIMS.findIndex((d) => d[0] === label)
        return (
          <Fragment key={label}>
            <span className='mo-cap' style={at(BX0, MROW(i) - 24)}>
              {label}
            </span>
            <span
              className='mo-bar'
              style={{ ...at(BX0, MROW(i) - 4), width: BX1 - BX0 }}
            />
            <span
              className='mo-band mo-band--transit'
              style={{
                ...at(lerpX(BX0, BX1, Math.max(0, lo - TRANSIT)), MROW(i) - 4),
                width: lerpX(
                  0,
                  BX1 - BX0,
                  Math.min(100, hi + TRANSIT) - Math.max(0, lo - TRANSIT)
                )
              }}
            />
            <span
              className='mo-band mo-band--ideal'
              style={{
                ...at(lerpX(BX0, BX1, lo), MROW(i) - 4),
                width: lerpX(0, BX1 - BX0, hi - lo)
              }}
            />
            <span className='mo-mark' data-mo='mc-mark' />
          </Fragment>
        )
      })}
      <span className='mo-tip' data-mo='mc-tip'>
        Im Interview vertiefen
      </span>
      <span className='mo-legend' style={at(BX0, 160)}>
        <span>
          <i style={{ background: 'rgb(167 247 231)' }} />
          Idealbereich
        </span>
        <span>
          <i style={{ background: 'rgb(253 218 148)' }} />
          Übergangsbereich
        </span>
        <span>
          <i style={{ background: '#4D7BF3', width: 8, borderRadius: '50%' }} />
          Lena M.
        </span>
      </span>
    </>
  )
}

export const PLAY_CONTENTS = {
  play: Play,
  done: Done,
  match: Match
}

export function buildPlay({ q, qa }) {
  const timer = q('pl-timer')
  const tiles = qa('pl-tile')
  const names = qa('pl-name')
  const dims = qa('pl-dim')
  const segs = qa('pl-seg')
  const score = q('mc-score')
  const tag = q('mc-tag')
  const marks = qa('mc-mark')
  const tip = q('mc-tip')

  return (t) => {
    // Zeitraffer: 4 Spiele in rund 14 Minuten
    const p = clamp((t - PLAY[0]) / (PLAY[1] - PLAY[0]))
    const secs = Math.round(p * MINUTES * 60)
    timer.textContent = `${String(Math.floor(secs / 60)).padStart(2, '0')}:${String(secs % 60).padStart(2, '0')}`
    GAMES.forEach(([, , a, b], i) => {
      const v = Math.min(
        i === 0 ? 1 : smooth((t - a) / 0.2),
        i === GAMES.length - 1 ? 1 : 1 - smooth((t - (b - 0.16)) / 0.16)
      )
      show(names[i], v)
      show(dims[i], v)
      segs[i].style.width = `${(clamp((t - a) / (b - a)) * 100).toFixed(1)}%`
    })
    tiles.forEach((tile, i) => {
      const k = TAPS.findIndex(
        (idx, j) => idx === i && t >= TAP_TIMES[j] && t < TAP_TIMES[j] + 0.38
      )
      tile.style.backgroundColor = k >= 0 ? '#4D7BF3' : '#2C3650'
      const s = k >= 0 ? 0.92 + 0.08 * step(t - TAP_TIMES[k], 26, 0.7) : 1
      tile.style.transform = `scale(${s.toFixed(3)})`
    })

    // Passung: Score zählt, Werte gleiten an ihren Platz
    score.textContent = String(Math.round(SCORE * easeInOut((t - 18.9) / 1.3)))
    show(tag, smooth((t - 20.1) / 0.22))
    marks.forEach((m, i) => {
      const v = PERSON[i] * step(t - (19.2 + i * 0.15), 12, 0.9)
      m.style.transform = `translate(${lerpX(BX0, BX1, v).toFixed(2)}px, ${MROW(i)}px) translate(-50%, -50%)`
      m.style.opacity = clamp((t - (19.2 + i * 0.15)) / 0.12).toFixed(3)
    })
    const tv = Math.min(
      smooth((t - 21.2) / 0.16),
      1 - smooth((t - 22.6) / 0.14)
    )
    tip.style.opacity = tv.toFixed(3)
    tip.style.transform = `translate(${lerpX(BX0, BX1, PERSON[HINT_ROW]).toFixed(2)}px, ${(MROW(HINT_ROW) - 18 + (1 - tv) * 8).toFixed(2)}px) translate(-50%, -100%)`
  }
}

export const PLAY_IDS = Object.keys(PLAY_CONTENTS)
